import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import { Box } from "@mui/material";
import Filter from "./Filter";
import CommonButton from "../../../CommonComponents/CommonButton";
import TuneIcon from "@mui/icons-material/Tune";
import { PropTypes } from "prop-types";
import FilterPopIcon from "../../../Images/Svg/FilterPopIcon.svg";

const FilterPopOver = ({
  isDateFilterClicked,
  isStatusFilterClicked,
  isDateIconClicked,
  isStatusIconClicked,
  anchorEl,
  isStatusItemClicked,
  dateFilterHandler = () => {},
  statusFilterHandler = () => {},
  statusItemHandler = () => {},
  startDateHandler = () => {},
  endDateHandler = () => {},
  handleFilterByTag = () => {},
  handleClick = () => {},
  handleClose = () => {},
  handleFilterApply = () => {},
  handleFilterReset = () => {},
}) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const buttonStyle = {
    fontSize: "2.8rem",
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem",
  };
  return (
    <div>
      <Box aria-describedby={id} variant="contained">
        <CommonButton
          onClick={handleClick}
          label=""
          id="filter"
          isIcon={true}
          iconName={
            <img src={FilterPopIcon} alt="Filter Icon" style={buttonStyle} />
          }
          backgroundColor={"#E8E8E8"}
          textColor={"#E42125"}
          removeBorder={true}
          smallButton={true}
          filledButton={false}
          removeBackGround={true}
        />
      </Box>
      <Popover
        sx={{ mt: "1rem" }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Filter
          dateFilterHandler={dateFilterHandler}
          statusFilterHandler={statusFilterHandler}
          statusItemHandler={statusItemHandler}
          startDateHandler={startDateHandler}
          endDateHandler={endDateHandler}
          handleFilterByTag={handleFilterByTag}
          isDateIconClicked={isDateIconClicked}
          isDateFilterClicked={isDateFilterClicked}
          isStatusIconClicked={isStatusIconClicked}
          isStatusFilterClicked={isStatusFilterClicked}
          handleFilterApply={handleFilterApply}
          handleFilterReset={handleFilterReset}
          isStatusItemClicked={isStatusItemClicked}
        />
      </Popover>
    </div>
  );
};
FilterPopOver.prototypes = {
  dateFilterHandler: PropTypes.func,
  statusFilterHandler: PropTypes.func,
  statusItemHandler: PropTypes.func,
  startDateHandler: PropTypes.func,
  endDateHandler: PropTypes.func,
  handleClose: PropTypes.func,
  handleClick: PropTypes.func,
  handleFilterByTag: PropTypes.func,
  handleFilterApply: PropTypes.func,
  handleFilterReset: PropTypes.func,
  isDateIconClicked: PropTypes.bool,
  isDateFilterClicked: PropTypes.bool,
  isStatusIconClicked: PropTypes.bool,
  isStatusFilterClicked: PropTypes.bool,
  anchorEl: PropTypes.bool,
};
export default FilterPopOver;
